import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { Key } from 'antd/es/table/interface';
import { CustomerReduced } from '@/core/domain/people/Customers/Customers.types';
import LoadMoreSummary from '../../LoadMoreSummary';

interface Props {
  isFetching: boolean;
  hasNextPage?: boolean;
  fetchNextPage: () => void;
  columns: ColumnsType<CustomerReduced>;
  customers: CustomerReduced[];
  selectedCustomersKeys: Key[];
  handleCustomersSelect: (values: Key[]) => void;
  noSelection?: boolean;
}

const CustomersTableModal: React.FC<Props> = ({
  isFetching,
  hasNextPage,
  fetchNextPage,
  columns,
  customers,
  selectedCustomersKeys,
  handleCustomersSelect,
  noSelection,
}) => {
  return (
    <Table<CustomerReduced>
      columns={columns}
      dataSource={customers}
      loading={isFetching}
      className="scroll-table"
      rowKey={(row) => row.id}
      pagination={false}
      summary={() =>
        hasNextPage ? (
          <LoadMoreSummary
            onClick={fetchNextPage}
            columnsCount={columns.length + 1}
          />
        ) : null
      }
      rowSelection={
        !noSelection
          ? {
              selectedRowKeys: selectedCustomersKeys,
              onChange: handleCustomersSelect,
              preserveSelectedRowKeys: true,
            }
          : undefined
      }
    />
  );
};

export default CustomersTableModal;
